import { render, staticRenderFns } from "./Create-Service.vue?vue&type=template&id=5005c99e"
import script from "./Create-Service.vue?vue&type=script&lang=js"
export * from "./Create-Service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports